import type { Dispatch, PropsWithChildren, SetStateAction } from "react";
import { createContext } from "react";
import type { FundraisingDocument, FundraisingDocumentsState } from "./fundraisingDocumentsState";

interface Props {
  documentsState: FundraisingDocumentsState;
  setDocumentsState: Dispatch<SetStateAction<FundraisingDocumentsState>>;
  filteredDocuments: FundraisingDocument[];
  onPreviewFile: (fileId: string) => void;
  onDownloadFile: (fileId: string) => void;
  onDownloadMultipleFiles: (fileIds: string[]) => void;
}

const FundraisingDocumentsContext = createContext<Props | undefined>(undefined);

export const FundraisingDocumentsContextProvider = ({ children, ...contextValue }: PropsWithChildren<Props>) => (
  <FundraisingDocumentsContext value={contextValue}>{children}</FundraisingDocumentsContext>
);

export default FundraisingDocumentsContext;
